/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Orgs_TitleInputs */

const cs_portal_orgs_title = /** @type {(inputs: Portal_Orgs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte organizaci`)
};

const en_portal_orgs_title = /** @type {(inputs: Portal_Orgs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose organization`)
};

/**
* | output |
* | --- |
* | "Choose organization" |
*
* @param {Portal_Orgs_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_orgs_title = /** @type {((inputs?: Portal_Orgs_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Orgs_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_orgs_title(inputs)
	return cs_portal_orgs_title(inputs)
});